export {
    DESCRIPTOR,
    type AdapterDescriptor,
} from '@/adapters/biology/registryInput';
export {
    SPACE_KEY,
    SPACE_SLUG,
} from '@/adapters/biology/spaceIdentity';
